// extracted by mini-css-extract-plugin
export var lg = "_hr-7";
export var md = "_hr-6";
export var placeholderContainer = "_hr-1";
export var placeholderIcon = "_hr-2";
export var productImage = "_hr-0";
export var sm = "_hr-5";
export var xl = "_hr-8";
export var xs = "_hr-4";
export var xxs = "_hr-3";